

























































































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import DateComponent from '@/components/common/Inputs/Date.vue';
import FormattedNumber from '@/components/common/Inputs/FormattedNumber.vue';
import VCurrencyField from "@/components/common/CurrencyInput/VCurrencyField.vue";
import DocumentRequestComponent from "./DocumentRequest.vue";
import { financialReport } from "@/store/modules/financialReport";
import { FinancialReportData } from "@/entities";
import { Locales } from "@/i18n/locales";

const namespace: string = "financialReport";

@Component({
  components: {
    DateComponent,
    FormattedNumber,
    DocumentRequestComponent,
    VCurrencyField
  }
})
export default class PersonnelTableComponent extends Vue {
  @State(namespace) financialReport!: FinancialReportData;

  @Prop() header: any;
  @Prop() items: any;
  @Prop() currencyList: any;
  @Prop() currency: string;
  @Prop() formOptions: any;
  @Prop() categories: Array<any>;
  @Prop() personnelCostRowDatas: Array<any>;
  @Prop() docItems: any;
  searchString = '';
  update = 0;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  editedItem: any = {
    rowId: undefined,
    period: undefined,
    empName: undefined,
    totCost: undefined,
    totCostEUR: undefined,
    budgetLine: undefined,
    hourlyRate: undefined,
    exchRate: undefined,
    grossSalary: undefined,
    costCharged: undefined,
    otherCost: undefined,
    currency: undefined,
    workHours: undefined,
    totalHours: undefined,
  };

  defaultItem: any = {
    rowId: undefined,
    period: undefined,
    empName: undefined,
    totCost: undefined,
    totCostEUR: undefined,
    budgetLine: undefined,
    hourlyRate: undefined,
    exchRate: undefined,
    grossSalary: undefined,
    costCharged: undefined,
    otherCost: undefined,
    currency: undefined,
    workHours: undefined,
    totalHours: undefined,
  };
  
  dialog = false;
  dialogDelete = false;
  editedIndex = -1;
  actions = _app.actions;
  subjects = _app.subjects;
  hasAuditPermission = false;
  includeFields = ["budgetLine"];

  close() {
    this.dialog = false;
    this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
    });
  }

  editItem(item) {
    this.editedIndex = this.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  findTotalCost(item) {
    if(item.grossSalary && (item.otherCost || item.otherCost == 0)) {
      item.totCost = utils.roundDecimal(item.grossSalary + item.otherCost);
    }
    this.findTotCostEUR(item);
  }
  findTotCostEUR(item) {
    if(item.totCost && item.exchRate) {
      item.totCostEUR = utils.roundDecimal(item.totCost * item.exchRate);
    }
    else{
      item.totCostEUR = undefined;
    }
    this.findHourlyRate(item);
  }
  findHourlyRate(item) {
    if(item.totCostEUR && item.workHours) {
        if (item.workHours > 0) {
            item.hourlyRate = utils.roundDecimal(item.totCostEUR / item.workHours);
        }
    }
    else{
      item.hourlyRate = undefined;
    }
    this.findCostCharged(item);
  }
  findCostCharged(item) {
    if(item.hourlyRate && item.totalHours) {
      item.costCharged = utils.roundDecimal(item.hourlyRate * item.totalHours);
    }
    else{
      item.costCharged = undefined;
    }
  }

  deleteItem(item) {
    this.editedIndex = this.items.indexOf(item);
    this.items.splice(this.editedIndex, 1);
    this.$emit('input', true);
  }

  closeDelete() {
    this.dialogDelete = false;
  }

  // formatDate(dt: any) {
  //   return utils.formatDate(dt);
  // }

  numberFormat(val, precision) {
    return utils.formatDecimal(val, precision, this.defaultLocale);
  }

  addResult() {
    let obj = Object.assign({}, this.defaultItem);
    obj.rowId = utils.generateGUID();
    this.items.push(obj);
    this.$emit('input', true);
    this.update += 1;
  }

  currencyFormat(val, format) {
    return utils.formatCurrency(val, format, this.defaultLocale);
  }

  save () {
    if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
    } else {
        this.items.push(this.editedItem)
    }
    this.close()
  }

  summary(key: any) {
    let sum = 0;
    if (this.items.length > 0) {
      this.items.map((row: any) => {
        sum += (row[key] || 0);
      });
    }
    return sum;
  }

  auditorHasPermission() {
    let hasPermission = false;

    hasPermission = (
      //@ts-ignore
      this.$can(this.actions.update, this.subjects.finReportAudit) &&
      this.financialReport.selectedReport.WorkFlowStatusId == _app.finReportAuditStatus.readyForAudit &&
      this.financialReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus == 0
    );

    return hasPermission;
  }

  isNumber(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 46
    ) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  setExchRate(item) {
    if (this.currencyList.find(x => x.Value == item.currency).DisplayText == this.currency)
      item.exchRate = 1;
    else
      item.exchRate = undefined;
  }

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
    } else {
        return null;
    }
  }

  fileDownload(item){
        const selectedDoc = this.docItems.find(doc => doc.name === item.mappedFileName);
        this.$services.document.download(selectedDoc);
    }
}
